/**
 * External Imports
 */
import styled, { css } from 'styled-components';

/**
 * Nexus Imports
 */
import { NeuCard, NeuIcon } from '@neutron/react';

interface IModalFooterProps {
  right?: boolean;
}

export const Card = styled(NeuCard)`
  display: flex;
  flex-direction: column;
  position: relative;
  background: #f6f6f6 !important;
  z-index: 10;
  padding-inline-start: 0;
  padding-inline-end: 0;
  padding-top: 0;
  padding-bottom: 0;
  margin-inline-end: 0;
  margin-top: 0;
`;

export const CardHeader = styled(NeuCard)`
  display: flex !important;
  flex-direction: row !important;
  justify-content: space-between !important;
  align-items: center;
  height: 56px;
  width: 100%;
  background: white !important;
  padding-top: calc(var(--card-spacing) / 2) !important;
`;

export const ModalTitle = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  font-size: 1rem;
`;

export const TitleIcon = styled(NeuIcon)`
  margin-right: 10px;
`;

export const ModalCardContent = styled(NeuCard)`
  flex: 1;
  overflow-y: scroll;
  overflow-x: hidden;
`;

export const ModalFooter = styled(NeuCard)<IModalFooterProps>`
  display: flex;
  justify-content: space-between;
  background: white !important;
  bottom: 0;
  height: 69px !important;
  padding-top: var(--card-spacing) !important;
  ${props =>
    !props.right &&
    css`
      display: flex !important;
      justify-content: space-between !important;
    `}
`;
